export const iconFontAwesomeHumanitarianSkullCrossbones = (
	<i className="fa-solid fa-skull-crossbones"></i>
);
